import React, { useEffect, useState } from "react";
import {
  FaPlay,
  FaPlus,
  FaChevronLeft,
  FaChevronRight,
  FaLink,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import styled from "styled-components";

import productsArray from "../../DataJS/Products.js";
import categoryData from "../../DataJS/categories.js";

const Products = () => {
  const [products, setProducts] = useState([]);
  // const [activeTab, setActiveTab] = useState("All");
  const [selectedCategory, setSelectedCategory] = useState("All");

  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    setProducts(productsArray);
  }, []);

  const filteredProducts =
    selectedCategory === "All"
      ? products
      : products.filter((product) => product.categoryId === selectedCategory);

  const handleCategoryChange = (categoryId) => {
    setSelectedCategory(categoryId);
    setCurrentIndex(0);
  };

  // Get the first image of a product
  // const getMainImage = (product) => {
  //   if (
  //     product?.images &&
  //     Array.isArray(product.images) &&
  //     product.images.length > 0
  //   ) {
  //     return product.images[0];
  //   }
  //   return "/assets/images/shop/placeholder.png";
  // };

  // Open Lightbox
  const openModal = (index) => {
    setCurrentIndex(index);
    setIsOpen(true);
  };

  // Close Lightbox
  const closeModal = () => {
    setIsOpen(false);
  };

  // Next Product
  const nextSlide = () => {
    setCurrentIndex((currentIndex + 1) % filteredProducts.length);
  };

  // Previous Product
  const prevSlide = () => {
    setCurrentIndex(
      (currentIndex - 1 + filteredProducts.length) % filteredProducts.length,
    );
  };

  return (
    <Wrapper>
      <section
        className="rs-shop-area section-space"
        style={{ paddingTop: "50px" }}
      >
        <div
          className="rs-section-title-wrapper"
          //   style={{ marginBottom: "50px" }}
        >
          <span className="rs-section-subtitle has-theme-orange justify-content-center">
            <FaPlay color="#EA5501" size={12} />
            Our Products
          </span>
        </div>

        <div className="container pt-4">
          <div className="row">
            <div className="col-md-12">
              <div className="product-tab-item">
                <div className="product-tab-menu d-flex justify-content-center align-items-center">
                  <ul
                    className="nav nav-pills mb-4 d-flex justify-content-center align-items-center gap-2 product-tabs"
                    role="tablist"
                  >
                    {/* ALL BUTTON */}
                    <li className="nav-item" role="presentation">
                      <button
                        type="button"
                        className={`nav-link ${
                          selectedCategory === "All" ? "active" : ""
                        }`}
                        onClick={() => handleCategoryChange("All")}
                      >
                        All
                      </button>
                    </li>

                    {/* CATEGORY BUTTONS */}
                    {categoryData.map((category) => (
                      <li
                        className="nav-item"
                        role="presentation"
                        key={category.id}
                      >
                        <button
                          type="button"
                          className={`nav-link ${
                            selectedCategory === category.id ? "active" : ""
                          }`}
                          onClick={() => handleCategoryChange(category.id)}
                          style={{
                            textTransform: "uppercase",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {category.category}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="tab-content">
                  <div className="tab-pane fade show active">
                    <div className="row g-4">
                      {filteredProducts.map((item, index) => {
                        // const mainImage = getMainImage(item);

                        return (
                          <div
                            className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12"
                            key={item.id}
                          >
                            <div
                              className="gallery-wrapper"
                              style={{ border: "1px solid #eeeeee" }}
                            >
                              <img
                                src={item.image}
                                // src={mainImage}
                                alt={item.title}
                                className="gallery-img"
                                // style={{width: "300px", height: "300px"}}
                              />

                              <div className="gallery-overlay"></div>

                              <div className="gallery-actions">
                                <button
                                  type="button"
                                  className="gallery-btn"
                                  onClick={() => openModal(index)}
                                  aria-label={`View ${item.title}`}
                                >
                                  <FaPlus />
                                </button>

                                <Link
                                  // to={item.link}
                                  to={`/products/product-details/${item.id}`}
                                  className="gallery-link-btn"
                                  aria-label={`View ${item.title}`}
                                >
                                  <FaLink />
                                </Link>
                              </div>

                              {/* Product Content */}
                              <div className="gallery-content">
                                <h4>{item.title}</h4>
                                <span className="text-capitalize fs-4">
                                  {item.subtitle}
                                </span>
                              </div>
                            </div>
                          </div>
                        );
                      })}

                      {/* No Products */}
                      {filteredProducts.length === 0 && (
                        <div className="col-12 text-center">
                          <p>No products available for this category.</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {isOpen && filteredProducts.length > 0 && (
        <div
          className="lightbox"
          onClick={closeModal}
          role="dialog"
          aria-modal="true"
        >
          <button
            type="button"
            className="close"
            onClick={closeModal}
            aria-label="Close"
          >
            &times;
          </button>

          <button
            type="button"
            className="lightbox-arrow prev"
            onClick={(event) => {
              event.stopPropagation();
              prevSlide();
            }}
            aria-label="Previous image"
          >
            <FaChevronLeft />
          </button>

          <div
            className="lightbox-content"
            onClick={(event) => event.stopPropagation()}
          >
            <img
              src={filteredProducts[currentIndex].image}
              // src={getMainImage(filteredProducts[currentIndex])}
              alt={filteredProducts[currentIndex].title}
              className="lightbox-img"
            />

            <div className="lightbox-info">
              <h4>{filteredProducts[currentIndex].title}</h4>
              <span className="text-capitalize fs-4">
                {filteredProducts[currentIndex].subtitle}
              </span>
            </div>
          </div>

          <button
            type="button"
            className="lightbox-arrow next"
            onClick={(event) => {
              event.stopPropagation();
              nextSlide();
            }}
            aria-label="Next image"
          >
            <FaChevronRight />
          </button>
        </div>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .gallery-wrapper {
    position: relative;
    width: 100%;
    height: 400px;
    overflow: hidden;
    border-radius: 10px;
    background: #f5f5f5;
    cursor: pointer;
  }

  .gallery-img {
    width: 100%;
    height: 100%;
    display: block;
    /* object-fit: cover; */
    object-fit: contain;
    object-position: center center;
    transition: transform 0.5s ease;
  }

  .gallery-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    opacity: 0;
    transition: opacity 0.35s ease;
    z-index: 1;
  }

  .gallery-actions {
    position: absolute;
    top: 50%;
    left: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    transform: translate(-50%, -50%) scale(0.7);
    opacity: 0;
    visibility: hidden;
    z-index: 3;
    transition: all 0.35s ease;
  }

  .gallery-btn,
  .gallery-link-btn {
    width: 42px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    background: #ff6118;
    border: none;
    border-radius: 50%;
    color: #ffffff;
    font-size: 14px;
    text-decoration: none;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .gallery-btn:hover,
  .gallery-link-btn:hover {
    background: #ea5501;
    color: #ffffff;
    transform: scale(1.08);
  }

  .gallery-content {
    position: absolute;
    left: 15px;
    right: 15px;
    bottom: 20px;
    z-index: 3;
    color: #ffffff;
    text-align: center;
    opacity: 0;
    transform: translateY(15px);
    transition: all 0.35s ease;
  }

  .gallery-content span {
    display: block;
    margin-bottom: 4px;
    color: #ffffff;
    font-size: 12px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 1px;
    text-align: center;
  }

  .gallery-content h4 {
    margin: 0;
    color: #ffffff;
    font-size: 20px;
    font-weight: 600;
    line-height: 1.3;
    text-align: center;
  }

  .gallery-wrapper:hover .gallery-img {
    transform: scale(1.07);
  }

  .gallery-wrapper:hover .gallery-overlay {
    opacity: 1;
  }

  .gallery-wrapper:hover .gallery-actions {
    opacity: 1;
    visibility: visible;
    transform: translate(-50%, -50%) scale(1);
  }

  .gallery-wrapper:hover .gallery-content {
    opacity: 1;
    transform: translateY(0);
  }

  /* ========  PRODUCT TAB  ======== */
  .product-tab-menu {
    width: 100%;
  }

  .product-tabs {
    padding-left: 0 !important;
    overflow-x: auto;
    flex-wrap: nowrap !important;
    -webkit-overflow-scrolling: touch;
  }

  .product-tabs .nav-item {
    margin-bottom: 7px;
  }

  .product-tabs .nav-link {
    border: 1px solid #e5e5e5;
    background: #ffffff;
    color: #333333;
    border-radius: 30px;
    padding: 10px 22px;
    font-size: 14px;
    font-weight: 600;
    transition: all 0.3s ease;
  }

  .product-tabs .nav-link:hover {
    background: #ff6118;
    border-color: #ff6118;
    color: #ffffff;
  }

  .product-tabs .nav-link.active {
    background: #ff6118;
    border-color: #ff6118;
    color: #ffffff;
  }

  .product-tabs::-webkit-scrollbar {
    height: 5px;
  }

  .product-tabs::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  .product-tabs::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  .product-tabs::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  .lightbox {
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 30px;
    background: rgba(0, 0, 0, 0.94);
    z-index: 99999;
  }

  .lightbox-content {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 90%;
    max-height: 90vh;
  }

  .lightbox-img {
    display: block;
    max-width: 100%;
    max-height: 75vh;
    object-fit: contain;
    border-radius: 8px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
    /* add background */
    background: #ffffff;
  }

  .lightbox-info {
    margin-top: 15px;
    text-align: center;
  }

  .lightbox-info span {
    display: block;
    color: #ff6118;
    font-size: 13px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  .lightbox-info h4 {
    margin: 5px 0 0;
    color: #ffffff;
    font-size: 22px;
    font-weight: 600;
  }

  .close {
    position: absolute;
    top: 20px;
    right: 30px;
    width: 45px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    color: #ffffff;
    font-size: 42px;
    font-weight: 300;
    line-height: 1;
    cursor: pointer;
    z-index: 10;
    transition: all 0.3s ease;
  }

  .close:hover {
    color: #ff6118;
    transform: rotate(90deg);
  }

  .lightbox-arrow {
    position: absolute;
    top: 50%;
    width: 55px;
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translateY(-50%);
    background: rgba(255, 255, 255, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.25);
    border-radius: 50%;
    color: #ffffff;
    font-size: 18px;
    cursor: pointer;
    z-index: 10;
    transition: all 0.3s ease;
  }

  .lightbox-arrow:hover {
    background: #ff6118;
    border-color: #ff6118;
  }

  .prev {
    left: 30px;
  }

  .next {
    right: 30px;
  }

  /* ========  TABLET  ======== */
  @media (max-width: 991px) {
    .gallery-wrapper {
      height: 280px;
    }

    .gallery-btn,
    .gallery-link-btn {
      width: 40px;
      height: 40px;
      font-size: 13px;
    }

    .lightbox-arrow {
      width: 48px;
      height: 48px;
    }

    .prev {
      left: 20px;
    }

    .next {
      right: 20px;
    }
  }

  /* ========  MOBILE  ======== */
  @media (max-width: 575px) {
    .product-tabs {
      justify-content: flex-start !important;
    }

    .gallery-wrapper {
      height: 250px;
    }

    .gallery-actions {
      gap: 5px;
    }

    .gallery-btn,
    .gallery-link-btn {
      width: 38px;
      height: 38px;
      font-size: 12px;
    }

    .gallery-content {
      left: 10px;
      right: 10px;
      bottom: 16px;
    }

    .gallery-content h4 {
      font-size: 18px;
    }

    .gallery-content span {
      font-size: 11px;
    }

    .lightbox {
      padding: 15px;
    }

    .lightbox-content {
      max-width: 100%;
    }

    .lightbox-img {
      max-width: 100%;
      max-height: 70vh;
    }

    .lightbox-info h4 {
      font-size: 18px;
    }

    .close {
      top: 10px;
      right: 15px;
      font-size: 36px;
    }

    .lightbox-arrow {
      width: 42px;
      height: 42px;
      font-size: 15px;
    }

    .prev {
      left: 10px;
    }

    .next {
      right: 10px;
    }
  }
`;

export default Products;

// import React, { useEffect, useState } from "react";
// import {
//   FaPlay,
//   FaPlus,
//   FaChevronLeft,
//   FaChevronRight,
//   FaLink,
// } from "react-icons/fa";
// import { Link } from "react-router-dom";
// import styled from "styled-components";

// import productsArray from "../../DataJS/Products.js";
// import categoryData from "../../DataJS/categories.js";

// const Products = () => {
//   const [products, setProducts] = useState([]);
//   const [selectedCategory, setSelectedCategory] = useState("All");

//   const [isOpen, setIsOpen] = useState(false);
//   const [currentIndex, setCurrentIndex] = useState(0);

//   useEffect(() => {
//     setProducts(productsArray);
//   }, []);

//   const filteredProducts =
//     selectedCategory === "All"
//       ? products
//       : products.filter((product) => product.categoryId === selectedCategory);

//   const handleCategoryChange = (categoryId) => {
//     setSelectedCategory(categoryId);
//     setCurrentIndex(0);
//   };

//   const openModal = (index) => {
//     setCurrentIndex(index);
//     setIsOpen(true);
//   };

//   const closeModal = () => {
//     setIsOpen(false);
//   };

//   const nextSlide = () => {
//     setCurrentIndex((currentIndex + 1) % filteredProducts.length);
//   };

//   const prevSlide = () => {
//     setCurrentIndex(
//       (currentIndex - 1 + filteredProducts.length) % filteredProducts.length,
//     );
//   };

//   return (
//     <Wrapper>
//       <section
//         className="rs-shop-area section-space"
//         style={{ paddingTop: "50px" }}
//       >
//         {/* SECTION TITLE */}
//         <div className="rs-section-title-wrapper">
//           <span className="rs-section-subtitle has-theme-orange justify-content-center">
//             <FaPlay color="#EA5501" size={12} />
//             Our Products
//           </span>
//         </div>

//         <div className="container pt-4">
//           <div className="row">
//             <div className="col-md-12">
//               <div className="product-tab-item">
//                 {/* CATEGORY MENU */}
//                 <div className="product-tab-menu d-flex justify-content-center align-items-center">
//                   <ul
//                     className="nav nav-pills mb-4 d-flex justify-content-center align-items-center gap-2 product-tabs"
//                     role="tablist"
//                   >
//                     {/* ALL */}
//                     <li className="nav-item" role="presentation">
//                       <button
//                         type="button"
//                         className={`nav-link ${
//                           selectedCategory === "All" ? "active" : ""
//                         }`}
//                         onClick={() => handleCategoryChange("All")}
//                       >
//                         All
//                       </button>
//                     </li>

//                     {/* CATEGORIES */}
//                     {categoryData.map((category) => (
//                       <li
//                         className="nav-item"
//                         role="presentation"
//                         key={category.id}
//                       >
//                         <button
//                           type="button"
//                           className={`nav-link ${
//                             selectedCategory === category.id ? "active" : ""
//                           }`}
//                           onClick={() => handleCategoryChange(category.id)}
//                           style={{
//                             textTransform: "uppercase",
//                             whiteSpace: "nowrap",
//                           }}
//                         >
//                           {category.category}
//                         </button>
//                       </li>
//                     ))}
//                   </ul>
//                 </div>

//                 {/* PRODUCT GRID */}
//                 <div className="tab-content">
//                   <div className="tab-pane fade show active">
//                     <div className="row g-4">
//                       {filteredProducts.map((item, index) => (
//                         <div
//                           className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12"
//                           key={item.id}

//                         >
//                           <div
//                             className="gallery-wrapper"
//                             style={{ backgroundColor: "#F3F8FE" }}
//                           >
//                             {/* IMAGE AREA */}
//                             <div className="gallery-image-wrapper" style={{ backgroundColor: "#F3F8FE" }}>

//                               <img
//                                 src={item.image}
//                                 alt={item.title}
//                                 className="gallery-img"
//                               />
//                             </div>

//                             {/* OVERLAY */}
//                             <div className="gallery-overlay"></div>

//                             {/* ACTION BUTTONS */}
//                             <div className="gallery-actions">
//                               <button
//                                 type="button"
//                                 className="gallery-btn"
//                                 onClick={() => openModal(index)}
//                                 aria-label={`View ${item.title}`}
//                               >
//                                 <FaPlus />
//                               </button>

//                               <Link
//                                 to={item.link}
//                                 className="gallery-link-btn"
//                                 aria-label={`View ${item.title}`}
//                               >
//                                 <FaLink />
//                               </Link>
//                             </div>

//                             {/* PRODUCT INFORMATION */}
//                             <div className="gallery-content">
//                               <h4>{item.title}</h4>
//                               <span>{item.subtitle}</span>
//                             </div>
//                           </div>
//                         </div>
//                       ))}

//                       {/* EMPTY STATE */}
//                       {filteredProducts.length === 0 && (
//                         <div className="col-12 text-center">
//                           <p>No products available for this category.</p>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* LIGHTBOX */}
//       {isOpen && filteredProducts.length > 0 && (
//         <div
//           className="lightbox"
//           onClick={closeModal}
//           role="dialog"
//           aria-modal="true"
//         >
//           {/* CLOSE */}
//           <button
//             type="button"
//             className="close"
//             onClick={closeModal}
//             aria-label="Close"
//           >
//             &times;
//           </button>

//           {/* PREVIOUS */}
//           <button
//             type="button"
//             className="lightbox-arrow prev"
//             onClick={(event) => {
//               event.stopPropagation();
//               prevSlide();
//             }}
//             aria-label="Previous image"
//           >
//             <FaChevronLeft />
//           </button>

//           {/* IMAGE */}
//           <div
//             className="lightbox-content"
//             onClick={(event) => event.stopPropagation()}
//           >
//             <div className="lightbox-image-wrapper">
//               <img
//                 src={filteredProducts[currentIndex].image}
//                 alt={filteredProducts[currentIndex].title}
//                 className="lightbox-img"
//               />
//             </div>

//             <div className="lightbox-info">
//               <h4>{filteredProducts[currentIndex].title}</h4>

//               <span>{filteredProducts[currentIndex].subtitle}</span>
//             </div>
//           </div>

//           {/* NEXT */}
//           <button
//             type="button"
//             className="lightbox-arrow next"
//             onClick={(event) => {
//               event.stopPropagation();
//               nextSlide();
//             }}
//             aria-label="Next image"
//           >
//             <FaChevronRight />
//           </button>
//         </div>
//       )}
//     </Wrapper>
//   );
// };

// const Wrapper = styled.section`
//   /* =========================================
//      PRODUCT GALLERY
//   ========================================= */

//   .gallery-wrapper {
//     position: relative;

//     width: 100%;
//     height: 400px;

//     overflow: hidden;

//     border-radius: 10px;

//     background: #ffffff;

//     border: 1px solid #eeeeee;

//     cursor: pointer;

//     display: flex;

//     align-items: center;
//     justify-content: center;
//   }

//   /* =========================================
//      IMAGE WRAPPER
//   ========================================= */

//   .gallery-image-wrapper {
//     position: absolute;

//     inset: 0;

//     width: 100%;
//     height: 100%;

//     display: flex;

//     align-items: center;
//     justify-content: center;

//     overflow: hidden;

//     background: #ffffff;

//     z-index: 0;
//   }

//   /* =========================================
//      MAIN PRODUCT IMAGE

//      IMPORTANT:
//      contain keeps the complete product visible.
//   ========================================= */

//   .gallery-img {
//     width: 100%;
//     height: 100%;

//     display: block;

//     object-fit: contain;

//     object-position: center center;

//     padding: 18px;

//     transform: scale(1);

//     transition: transform 0.5s ease;
//   }

//   /* =========================================
//      SUBTLE ZOOM
//   ========================================= */

//   .gallery-wrapper:hover .gallery-img {
//     transform: scale(1.06);
//   }

//   /* =========================================
//      OVERLAY
//   ========================================= */

//   .gallery-overlay {
//     position: absolute;

//     inset: 0;

//     background: rgba(0, 0, 0, 0.42);

//     opacity: 0;

//     transition: opacity 0.35s ease;

//     z-index: 1;

//     pointer-events: none;
//   }

//   .gallery-wrapper:hover .gallery-overlay {
//     opacity: 1;
//   }

//   /* =========================================
//      ACTION BUTTONS
//   ========================================= */

//   .gallery-actions {
//     position: absolute;

//     top: 50%;
//     left: 50%;

//     display: flex;

//     align-items: center;
//     justify-content: center;

//     gap: 8px;

//     transform: translate(-50%, -50%) scale(0.7);

//     opacity: 0;

//     visibility: hidden;

//     z-index: 3;

//     transition: all 0.35s ease;
//   }

//   .gallery-wrapper:hover .gallery-actions {
//     opacity: 1;

//     visibility: visible;

//     transform: translate(-50%, -50%) scale(1);
//   }

//   .gallery-btn,
//   .gallery-link-btn {
//     width: 42px;
//     height: 42px;

//     display: flex;

//     align-items: center;
//     justify-content: center;

//     padding: 0;

//     background: #ff6118;

//     border: none;

//     border-radius: 50%;

//     color: #ffffff;

//     font-size: 14px;

//     text-decoration: none;

//     cursor: pointer;

//     transition: all 0.3s ease;
//   }

//   .gallery-btn:hover,
//   .gallery-link-btn:hover {
//     background: #ea5501;

//     color: #ffffff;

//     transform: scale(1.08);
//   }

//   /* =========================================
//      PRODUCT CONTENT
//   ========================================= */

//   .gallery-content {
//     position: absolute;

//     left: 15px;
//     right: 15px;

//     bottom: 20px;

//     z-index: 3;

//     color: #ffffff;

//     text-align: center;

//     opacity: 0;

//     transform: translateY(15px);

//     transition: all 0.35s ease;

//     pointer-events: none;
//   }

//   .gallery-wrapper:hover .gallery-content {
//     opacity: 1;

//     transform: translateY(0);
//   }

//   .gallery-content span {
//     display: block;

//     margin-bottom: 4px;

//     color: #ffffff;

//     font-size: 12px;

//     font-weight: 500;

//     text-transform: uppercase;

//     letter-spacing: 1px;

//     text-align: center;
//   }

//   .gallery-content h4 {
//     margin: 0;

//     color: #ffffff;

//     font-size: 20px;

//     font-weight: 600;

//     line-height: 1.3;

//     text-align: center;
//   }

//   /* =========================================
//      PRODUCT TABS
//   ========================================= */

//   .product-tab-menu {
//     width: 100%;
//   }

//   .product-tabs {
//     padding-left: 0 !important;

//     overflow-x: auto;

//     flex-wrap: nowrap !important;

//     -webkit-overflow-scrolling: touch;
//   }

//   .product-tabs .nav-item {
//     margin-bottom: 7px;
//   }

//   .product-tabs .nav-link {
//     border: 1px solid #e5e5e5;

//     background: #ffffff;

//     color: #333333;

//     border-radius: 30px;

//     padding: 10px 22px;

//     font-size: 14px;

//     font-weight: 600;

//     transition: all 0.3s ease;
//   }

//   .product-tabs .nav-link:hover {
//     background: #ff6118;

//     border-color: #ff6118;

//     color: #ffffff;
//   }

//   .product-tabs .nav-link.active {
//     background: #ff6118;

//     border-color: #ff6118;

//     color: #ffffff;
//   }

//   .product-tabs::-webkit-scrollbar {
//     height: 5px;
//   }

//   .product-tabs::-webkit-scrollbar-track {
//     background: #f1f1f1;
//   }

//   .product-tabs::-webkit-scrollbar-thumb {
//     background: #888;

//     border-radius: 4px;
//   }

//   .product-tabs::-webkit-scrollbar-thumb:hover {
//     background: #555;
//   }

//   /* =========================================
//      LIGHTBOX
//   ========================================= */

//   .lightbox {
//     position: fixed;

//     inset: 0;

//     width: 100%;
//     height: 100vh;

//     display: flex;

//     align-items: center;
//     justify-content: center;

//     padding: 30px;

//     background: rgba(0, 0, 0, 0.94);

//     z-index: 99999;
//   }

//   .lightbox-content {
//     position: relative;

//     display: flex;

//     flex-direction: column;

//     align-items: center;

//     justify-content: center;

//     width: auto;

//     max-width: 90vw;

//     max-height: 90vh;
//   }

//   .lightbox-image-wrapper {
//     width: auto;

//     max-width: 85vw;

//     max-height: 75vh;

//     display: flex;

//     align-items: center;
//     justify-content: center;

//     background: #ffffff;

//     border-radius: 8px;

//     padding: 10px;

//     overflow: hidden;
//   }

//   .lightbox-img {
//     display: block;

//     width: auto;
//     height: auto;

//     max-width: 100%;
//     max-height: 70vh;

//     object-fit: contain;

//     object-position: center;

//     border-radius: 4px;

//     box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
//   }

//   /* =========================================
//      LIGHTBOX INFO
//   ========================================= */

//   .lightbox-info {
//     margin-top: 15px;

//     text-align: center;
//   }

//   .lightbox-info span {
//     display: block;

//     color: #ff6118;

//     font-size: 13px;

//     font-weight: 500;

//     text-transform: uppercase;

//     letter-spacing: 1px;
//   }

//   .lightbox-info h4 {
//     margin: 5px 0 0;

//     color: #ffffff;

//     font-size: 22px;

//     font-weight: 600;
//   }

//   /* =========================================
//      CLOSE BUTTON
//   ========================================= */

//   .close {
//     position: absolute;

//     top: 20px;
//     right: 30px;

//     width: 45px;
//     height: 45px;

//     display: flex;

//     align-items: center;
//     justify-content: center;

//     background: transparent;

//     border: none;

//     color: #ffffff;

//     font-size: 42px;

//     font-weight: 300;

//     line-height: 1;

//     cursor: pointer;

//     z-index: 10;

//     transition: all 0.3s ease;
//   }

//   .close:hover {
//     color: #ff6118;

//     transform: rotate(90deg);
//   }

//   /* =========================================
//      LIGHTBOX ARROWS
//   ========================================= */

//   .lightbox-arrow {
//     position: absolute;

//     top: 50%;

//     width: 55px;
//     height: 55px;

//     display: flex;

//     align-items: center;
//     justify-content: center;

//     transform: translateY(-50%);

//     background: rgba(255, 255, 255, 0.12);

//     border: 1px solid rgba(255, 255, 255, 0.25);

//     border-radius: 50%;

//     color: #ffffff;

//     font-size: 18px;

//     cursor: pointer;

//     z-index: 10;

//     transition: all 0.3s ease;
//   }

//   .lightbox-arrow:hover {
//     background: #ff6118;

//     border-color: #ff6118;
//   }

//   .prev {
//     left: 30px;
//   }

//   .next {
//     right: 30px;
//   }

//   /* =========================================
//      TABLET
//   ========================================= */

//   @media (max-width: 991px) {
//     .gallery-wrapper {
//       height: 320px;
//     }

//     .gallery-img {
//       padding: 15px;
//     }

//     .gallery-btn,
//     .gallery-link-btn {
//       width: 40px;
//       height: 40px;

//       font-size: 13px;
//     }

//     .lightbox-arrow {
//       width: 48px;
//       height: 48px;
//     }

//     .prev {
//       left: 20px;
//     }

//     .next {
//       right: 20px;
//     }
//   }

//   /* =========================================
//      MOBILE
//   ========================================= */

//   @media (max-width: 575px) {
//     .product-tabs {
//       justify-content: flex-start !important;
//     }

//     .gallery-wrapper {
//       height: 280px;

//       border-radius: 8px;
//     }

//     .gallery-img {
//       padding: 12px;
//     }

//     .gallery-actions {
//       gap: 5px;
//     }

//     .gallery-btn,
//     .gallery-link-btn {
//       width: 38px;
//       height: 38px;

//       font-size: 12px;
//     }

//     .gallery-content {
//       left: 10px;
//       right: 10px;

//       bottom: 16px;
//     }

//     .gallery-content h4 {
//       font-size: 18px;
//     }

//     .gallery-content span {
//       font-size: 11px;
//     }

//     .lightbox {
//       padding: 15px;
//     }

//     .lightbox-content {
//       max-width: 100%;
//     }

//     .lightbox-image-wrapper {
//       max-width: 90vw;

//       max-height: 70vh;

//       padding: 8px;
//     }

//     .lightbox-img {
//       max-width: 100%;

//       max-height: 65vh;
//     }

//     .lightbox-info h4 {
//       font-size: 18px;
//     }

//     .close {
//       top: 10px;

//       right: 15px;

//       font-size: 36px;
//     }

//     .lightbox-arrow {
//       width: 42px;
//       height: 42px;

//       font-size: 15px;
//     }

//     .prev {
//       left: 10px;
//     }

//     .next {
//       right: 10px;
//     }
//   }
// `;

// export default Products;
